import "core-js/modules/es.array.includes.js";
import { VxeLayoutContainer } from 'vxe-pc-ui';
export default {
  name: 'XLayout',
  components: {
    VxeLayoutContainer
  },
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: value => ['medium', 'small', 'mini'].includes(value),
      default: 'medium'
    }
  }
};